export function logWarning(message: string) {
	if (process.env.NODE_ENV === 'development') {
		// eslint-disable-next-line no-console
		console.warn(`Localizer warning: ${message}`);
	}
}
